import { Box } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { LIMITED_ACCESS_INFO_FULL_PATH } from "./paths";

interface LimitedAccessBannerProps {
  leadTimeThresholdInHrs: number;
}

export function LimitedAccessBanner(props: LimitedAccessBannerProps) {
  const { leadTimeThresholdInHrs } = props;

  const history = useHistory();

  const handleClick = () => {
    logEvent(APP_V2_USER_EVENTS.LIMITED_ACCESS_BANNER_CTA_TAPPED);
    history.push(LIMITED_ACCESS_INFO_FULL_PATH);
  };

  return (
    <Box sx={{ position: "relative", height: "100%" }}>
      <PromotionBanner
        title="You're on Limited Access"
        subtitle={`You can claim shifts that start within ${leadTimeThresholdInHrs} hours.`}
        icon="membership-limited-colored"
        borderVariant="none"
        backgroundColor={(theme) => theme.palette.intent?.warning?.background ?? ""}
        titleColor={(theme) => theme.palette.intent?.warning?.text ?? ""}
        ctaButtonText="Learn more"
        sx={{
          height: "100%",
          "& svg": {
            alignSelf: "flex-start",
          },
        }}
        onClick={handleClick}
      />
    </Box>
  );
}
